import type { EnglishTestQuestionDto } from '@/api/generated/models'
import type { EnglishTestAnswerReview } from '../types'

export function normalizeAnswerText(value: string | null | undefined) {
  return (value ?? '').trim().replace(/\s+/g, ' ').toLowerCase()
}

export function getSortedCorrectAnswers(question: EnglishTestQuestionDto) {
  return [...(question.answers ?? [])]
    .sort((left, right) => (left.displayOrder ?? Number.MAX_SAFE_INTEGER) - (right.displayOrder ?? Number.MAX_SAFE_INTEGER))
    .filter(answer => answer.correct === true)
}

export function getCorrectAnswerTexts(question: EnglishTestQuestionDto) {
  return getSortedCorrectAnswers(question).map(answer => answer.answerText ?? '').filter(Boolean)
}

export function buildAnswerReview(
  question: EnglishTestQuestionDto,
  input: {
    selectedAnswerId: number | null
    selectedAnswerText: string
    correctAnswerTexts: string[]
    locallyCorrect: boolean | null
    backendCorrect: boolean | null
    pointsEarned: number | null
  }
): EnglishTestAnswerReview {
  return {
    questionId: question.id ?? null,
    questionText: question.questionText ?? '',
    questionType: question.questionType ?? '',
    selectedAnswerId: input.selectedAnswerId,
    selectedAnswerText: input.selectedAnswerText,
    correctAnswerTexts: input.correctAnswerTexts,
    locallyCorrect: input.locallyCorrect,
    backendCorrect: input.backendCorrect,
    pointsEarned: input.pointsEarned
  }
}
